import { useMutation } from 'react-query';
import { performanceReportingApiUrl, fetcher, createParamString } from 'data_sources/constants';
import type { ServerErrorResponse } from 'data_sources/constants';
import {
  downloadFileFromBase64,
  type DownloadableFileType,
} from 'views/App/Portal/Policy/DraftManuals/helpers/exportHelper';

export type EisFlaggedPersonnelExportParams = {
  search?: string;
  status?: string;
};

type EisFlaggedPersonnelExportResponse = {
  base64: string;
  fileType: DownloadableFileType;
};

export const getEisFlaggedPersonnelExport = async (
  ruleId: number,
  params: EisFlaggedPersonnelExportParams = {},
): Promise<void> => {
  const baseUrl = `${performanceReportingApiUrl()}/performance/eis/v1/rules/${ruleId}/flagged-personnel/export`;
  const queryParams = createParamString(params);
  const fullUrl = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;

  const response: EisFlaggedPersonnelExportResponse & Partial<ServerErrorResponse> = await fetcher({
    url: fullUrl,
    method: 'GET',
  });

  if (response.errorDetails) {
    throw new Error(JSON.stringify(response));
  }

  downloadFileFromBase64({
    base64Content: response.base64,
    fileName: `flagged-personnel-${ruleId}`,
    fileType: response.fileType,
  });
};

export const useEisFlaggedPersonnelExport = (ruleId: number) => {
  return useMutation((params: EisFlaggedPersonnelExportParams = {}) =>
    getEisFlaggedPersonnelExport(ruleId, params),
  );
};
